export const scrollHelper = (ref) => {
  ref?.current?.scrollIntoView({
    // behavior: "smooth",
    block: "center",
    inline: "center",
  });
};
